import styled from 'styled-components'

const darkText = '#333'
const lightText = '#FFF'
const mainColor = 'var(--main-color)'

interface UserMenuStyledProps {
  $themedark?: boolean
  $collapsemenu?: boolean
}

export const UserMenuStyled = styled.div<UserMenuStyledProps>`
  font-weight: 500;
  width: ${({ $collapsemenu }) => ($collapsemenu ? '80px' : '270px')};

  transition: width 0.3s ease;
  border: 1px solid #f0f0f0;
  box-shadow: 0 0px 12px 0 rgba(0, 0, 0, 0.07);
  background-color: rgb(255, 255, 255) !important;
  border-radius: 10px;
  padding-top: 5px;
  margin-left: -16px;
  margin-top: 2px;
  ul {
    background-color: transparent;
    font-size: 14px;
  }
  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open {
    .ant-menu.ant-menu-sub.ant-menu-inline {
      background-color: #f5f5f5 !important;
    }
  }
  .ant-menu-inline-collapsed > .ant-menu-item,
  .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
    font-weight: bold !important;
  }
  .ant-menu-title-content {
    font-weight: 600;
  }
  .ant-menu .ant-menu-sub {
    .ant-menu-item {
      padding-left: 72px !important;
      .ant-menu-title-content {
        font-weight: 200 !important;
      }
    }
  }
  .ant-menu .ant-menu-item {
    overflow: initial;
    position: relative;
    .ant-badge {
      position: unset;
    }
  }
  .ant-menu .ant-menu-item-selected {
    font-weight: bold !important;
    background-color: rgb(255, 255, 255) !important;
    color: ${mainColor} !important;
    border-radius: 10px;
  }

  .ant-menu-item::after {
    border-right: none !important;
  }
  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open {
    .ant-menu-submenu-title {
      font-weight: bold !important;
    }
  }
  .ant-menu-sub .ant-menu-item {
    font-weight: 400;
  }

  .socket .ant-badge-count {
    transform: translate(-40%, 55%) !important;
  }

  .side-bar-wrapper {
    height: calc(100vh - 57px);

    background-color: transparent;
    .menu-antd-user,
    .menu-antd-admin {
      height: calc(100vh - 45px);
      overflow: hidden auto;
      &::-webkit-scrollbar {
        width: 0px !important;
      }
    }
    .sub-menu {
      padding: 16px 0 16px 24px;
      .ant-switch {
        width: 70px;
        height: 30px;
        .ant-switch-handle {
          width: 26px;
          height: 26px;
          &::before {
            border-radius: 15px;
          }
        }
        &.ant-switch-checked .ant-switch-handle {
          inset-inline-start: calc(100% - 29px);
        }
        .ant-switch-inner-checked,
        .ant-switch-inner-unchecked {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          color: #fff566;
        }
        .ant-switch-inner-unchecked {
          height: 50% !important;
          font-size: 20px !important;
        }
      }
    }

    .icon-option {
      cursor: pointer;
      svg path {
        fill: ${({ $themedark }) => ($themedark ? lightText : darkText)};
      }
    }

    .collapsed-item {
      width: 100%;
      padding: 20px 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      font-weight: 500;
      background-color: #fff;
      .collapsed-icon {
        margin-right: ${({ $collapsemenu }) => ($collapsemenu ? '0' : '16px')};
        width: ${({ $collapsemenu }) => ($collapsemenu ? '100%' : 'auto')};
        text-align: center;
        svg {
          width: ${({ $collapsemenu }) => ($collapsemenu ? '20px' : '20px')};
          height: ${({ $collapsemenu }) => ($collapsemenu ? '20px' : '20px')};
        }
        svg path {
          fill: ${({ $themedark }) => ($themedark ? lightText : darkText)};
        }
      }
      .collapsed-title {
        display: ${({ $collapsemenu }) => ($collapsemenu ? 'none' : 'block')};
        color: ${({ $themedark }) => ($themedark ? lightText : darkText)};
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }

  .header-content {
    padding: 24px 16px 32px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`
